import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

import currentUser from '../../store/currentUser';
import ForbiddenView from '../../views/ForbiddenView';
import { API_PERMISSIONS } from '../../globals';
import { observer } from 'mobx-react';


@observer
class PermissionRoute extends React.Component {
  static propTypes = {
    path: PropTypes.string.isRequired,
  };

  render() {
    const { path } = this.props;
    if (path in API_PERMISSIONS && !currentUser.can(API_PERMISSIONS[path])) {
      return <ForbiddenView />;
    }
    return <Route {...this.props} />;
  }
}


export default PermissionRoute;
